// extracted by mini-css-extract-plugin
export var container = "_dq-1";
export var cornerButtonContainer = "_dq-6";
export var disabled = "_dq-2";
export var dragActive = "_dq-3";
export var fileContainer = "_dq-5";
export var hiddenInput = "_dq-4";
export var widthContainer = "_dq-0";